/**
 * Ordering for a picker's option list.
 *
 * Options reach the rail as STRINGS, because that is what the checklist
 * pickers compare against and what the filter slots store. A bare
 * `Array.prototype.sort()` on them is therefore lexicographic, which is right
 * for a name and wrong for a number:
 *
 *   Surrender Years, real values 1 / 3 / 5 / 7 / 10   ->   1, 10, 3, 5, 7
 *
 * So "10" rendered second, directly under "1" — two adjacent options a
 * fortnight apart in meaning, which is how a mis-click on "1" happens.
 *
 * Numeric ordering is applied only when EVERY value parses as a finite number.
 * That keeps it a no-op for the string dimensions sharing this path (Index,
 * Strategy combo, Mktg Name, Strategy Name, A.M. Best) and for mixed ones like
 * RILA's `perchangeterm`, whose values are "Annual" / "1 Year" / "6 Year".
 */
export function sortOptionValues(values: string[]): string[] {
  const out = [...values];
  const allNumeric = out.length > 0 && out.every(v => v.trim() !== '' && Number.isFinite(Number(v)));
  return allNumeric
    ? out.sort((a, b) => Number(a) - Number(b))
    : out.sort();
}
